import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.1 1.8C1.6 5 .5 7.8.5 20s1.1 15 7.6 18.2c4.7 2.5 19.1 2.5 23.8 0 6.5-3.2 7.6-6 7.6-18.2S38.4 5 31.9 1.8C27.2-.7 12.8-.7 8.1 1.8M9.7 12c.7 2.6 4 2.6 4.8-.1.5-1.4 1.4-1.9 2.8-1.7 2 .3 2.2.9 2.2 6.3s-.2 6-2.2 6.3c-1.7.3-2.4-.3-2.9-2.3-.8-3.2-3.8-3-4.2.3-.3 1.6-1 2.2-2.8 2.2-2.3 0-2.4-.3-2.4-6.5 0-5.9.2-6.5 2.1-6.5 1.2 0 2.3.8 2.6 2m18-.9c.8.8 1.7.8 3.3-.1 1.8-1 2.5-.9 3.8.4 1.4 1.4 1.5 2 .4 3.7-1 1.6-1.1 2.4-.1 3.5 1 1.2.9 1.8-.5 3.2-1.3 1.4-2 1.4-3.6.4s-2.4-1-4 0-2.3 1-3.6-.3c-1.3-1.4-1.4-2-.3-3.7s1-2.3-.1-3.7c-1.2-1.5-1.2-1.9.5-3.1 2.3-1.7 2.8-1.7 4.2-.3m1.9 15c1.4 2.3-3.3 5.2-9 5.7-5.2.4-5.6.3-5.6-1.6 0-1.7.8-2.2 3.8-2.7 2-.3 4.4-1 5.2-1.5 2.1-1.2 4.8-1.2 5.6.1" }, null, -1)
  ])))
}
export default { render: render }